import { useParams } from "react-router-dom";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { dataGridNestedColumnGetter } from "../../actprep-ui/utils/tables";
import PaginatedTable from "../../actprep-ui/components/PaginatedTable";
import { sexyBooleanColumn } from "../../actprep-ui/constants/dataGrid";
import { useCallback } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { fullName } from "../../actprep-ui/utils/formatting";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";

const goodNewsTextIntro = (item, i) => {
  if (item.student.school) {
    return `${i + 1}. ${fullName(item.student)} (${
      item.student.school?.name || "No School"
    })${item.current_team ? `(${item.current_team})` : ""}`;
  }
  return `${i + 1}. ${fullName(item.student)} ${
    item.current_team ? `(${item.current_team})` : ""
  }`;
};

const sortDesc = (data, metric) => {
  return [...data.sort((a, b) => b[metric] - a[metric])];
};

export default function LTQuizGoodNews({ filters }) {
  const { goodNewsType } = useParams();
  const tableApiRef = useGridApiRef();

  const copyGoodNews = useCallback(async () => {
    const quizData = sortDesc(
      sortDesc(tableApiRef.current.getSortedRows(), "quiz_average"),
      "quiz_score"
    );
    const quizText = quizData
      .map((week, i) => {
        return `${goodNewsTextIntro(week, i)}: ${Math.round(
          week.quiz_score
        )}% - ${Math.round(week.quiz_average)}% average\n`;
      })
      .join("");

    const goodNews =
      `Leadership Team Quiz Score Good News:\n${quizText}`.trim();
    await navigator.clipboard.writeText(goodNews);
    showSuccessSnackbar("Copied!");
  }, [tableApiRef]);

  const columns = [
    {
      field: "student.first_name",
      headerName: "First name",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "student.last_name",
      headerName: "Last name",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "quiz_score",
      headerName: "Quiz Score",
    },
    {
      field: "quiz_average",
      headerName: "Quiz Average",
      valueFormatter: (val) => Math.round(val),
    },
    {
      field: "student.school.name",
      headerName: "School",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "current_team",
      headerName: "Team",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "in_the_game",
      headerName: "In The Game",
      renderCell: sexyBooleanColumn,
    },
  ];
  return (
    <PaginatedTable
      pagination={false}
      apiRef={tableApiRef}
      tableName={"Score Good News"}
      apiUrl={apiUrls.admin.goodNews(goodNewsType)}
      urlParams={{
        search_params: filters,
      }}
      columns={columns}
      alwaysShowActions
      actions={[
        {
          label: "Copy Text Message",
          onClick: copyGoodNews,
        },
      ]}
    />
  );
}
